<template>
  <!-- renders slot content if the user is logged in and has permission to view content -->
  <div v-if="allowed">
    <slot />
  </div>
  <!-- if not then the loading spinner appears, after 1 second the login view appears -->
  <div v-else>
    <LoginCard v-if="login" />
    <b-loading :active="!login" :is-full-page="false" :can-cancel="false" />
  </div>
</template>

<script>
import { auth, db } from "@/firebase";
import LoginCard from "@/components/LoginCard.vue";

export default {
  name: "Permissions",
  components: {
    LoginCard,
  },
  props: {
    userId: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      permissions: [],
      login: false,
    };
  },
  computed: {
    organizationId() {
      return this.$route.params.organizationId;
    },
    stored_permissions() {
      return this.$store.getters.getPermissions;
    },
    // case for translator dashboard where orgId does not make sense
    user_permission() {
      let user = this.$store.getters.getCurrentUser;
      // check if user is logged in and we are looking to match userId
      if (user && this.userId != "" && !user.isAnonymous) {
        if (user.uid == this.userId) {
          return true;
        }
      }
      return false;
    },
    allowed() {
      // platform admin check
      // disable platform access where userId is aksed for
      if (this.stored_permissions.includes("platform") && this.userId == "") {
        // console.log("step1");
        return true;
      }
      if (this.stored_permissions.includes(this.organizationId)) {
        // console.log("step2");
        return true;
      }
      if (this.user_permission) {
        // console.log("step3");
        return true;
      }
      return false;
    },
  },
  watch: {
    organizationId: {
      immediate: true,
      async handler(organizationId) {
        if (organizationId) {
          await this.$bind("permissions", db.collection("organizations").doc(this.organizationId).collection("admins"));
          this.setPermissionInStore();
        } else {
          // this covers admin page, as there is no organizationId
          this.login = true;
        }
      },
    },
  },
  mounted() {
    auth.onAuthStateChanged(async (user) => {
      if (user) {
        if (user.isAnonymous) {
          //this.$store.dispatch('logOutUser')
        }
        // rebind after user logs in, because permissions get flushed with logout
        this.setPermissionInStore();
      } else {
        this.login = true;
      }
    });
  },
  methods: {
    setPermissionInStore() {
      // 1. if user is already allowed we don't need to add permissions again, as they are either set already OR the user is platform admin
      // 2. no use in updating permissions if no user is logged in
      // 3. when the page first loads the user is logged in onMount, but the Firestore Information hasn't loaded yet, so this.permissions is still empty.
      // Because we don't know if the user has permissions we don't want to set login to true as this would disrupt the loading animation
      if (!this.allowed && auth.currentUser && this.permissions.length !== 0) {
        if (this.permissions.map((y) => y.userId).includes(auth.currentUser.uid)) {
          this.$store.commit("SET_PERMISSION", this.$route.params.organizationId);
        } else {
          this.login = true;
        }
      }
    },
  },
};
</script>
